import React, { useState } from 'react';
const FAQ_ITEMS = [{
  question: 'What is this UX guide?',
  answer: 'This is a short A\u2013Z guide explaining common UX, brand and marketing terms in plain English. It is designed to make project meetings clearer and more productive.'
}, {
  question: 'Who is this guide for?',
  answer: 'It\u2019s for founders, marketing leads and anyone involved in brand, website or digital projects who wants clearer conversations and better outcomes.'
}, {
  question: 'What does UX mean?',
  answer: 'UX stands for user experience. It refers to how people interact with a product, website or service and how that experience feels overall.'
}];
export function FaqSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  const toggleIndex = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };
  return <section style={{
    display: 'flex',
    flexDirection: 'column',
    gap: '2.5rem',
    paddingTop: '4rem',
    borderTop: '1px solid #E5E5E0'
  }} data-id="element-40">
      <h2 style={{
      lineHeight: '1.2'
    }} className="text-[#000000] text-[16px]" data-id="element-41">
        Frequently Asked Questions
      </h2>

      <div style={{
      display: 'flex',
      flexDirection: 'column',
      borderTop: '1px solid #E5E5E0'
    }} data-id="element-42">
        {FAQ_ITEMS.map((item, idx) => {
        const isOpen = openIndex === idx;
        return <div key={idx} style={{
          borderBottom: '1px solid #E5E5E0'
        }} data-id="element-43">
              <button onClick={() => toggleIndex(idx)} aria-expanded={isOpen} aria-controls={`faq-answer-${idx}`} style={{
            width: '100%',
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            padding: '1.25rem 0',
            background: 'transparent',
            border: 'none',
            cursor: 'pointer',
            textAlign: 'left'
          }} data-id="element-44">
                <h3 style={{
              fontWeight: 600,
              lineHeight: '1.3',
              fontSize: '16px',
              color: '#000000',
              margin: 0
            }} data-id="element-45">
                  {item.question}
                </h3>
                <span style={{
              marginLeft: '1rem',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              color: '#8A8A85',
              fontSize: '18px',
              fontWeight: 300,
              lineHeight: 1,
              userSelect: 'none',
              transition: 'transform 150ms ease',
              transform: isOpen ? 'rotate(45deg)' : 'rotate(0deg)'
            }} data-id="element-46">
                  +
                </span>
              </button>

              <div id={`faq-answer-${idx}`} style={{
            display: 'grid',
            gridTemplateRows: isOpen ? '1fr' : '0fr',
            opacity: isOpen ? 1 : 0,
            transition: 'grid-template-rows 150ms ease, opacity 150ms ease'
          }} data-id="element-47">
                <div style={{
              overflow: 'hidden'
            }} data-id="element-48">
                  <div style={{
                paddingBottom: '1.25rem'
              }} data-id="element-49">
                    <p style={{
                  lineHeight: '1.7',
                  fontSize: '16px',
                  color: '#000000',
                  margin: 0
                }} data-id="element-50">
                      {item.answer}
                    </p>
                  </div>
                </div>
              </div>
            </div>;
      })}
      </div>

      <script type="application/ld+json" dangerouslySetInnerHTML={{
      __html: JSON.stringify({
        '@context': 'https://schema.org',
        '@type': 'FAQPage',
        mainEntity: FAQ_ITEMS.map(item => ({
          '@type': 'Question',
          name: item.question,
          acceptedAnswer: {
            '@type': 'Answer',
            text: item.answer
          }
        }))
      })
    }} data-id="element-51" />
    </section>;
}